var cibExpertsExchange = ["32 32", "<path d='M9.708 1.198h-9.708l11.146 14.802-11.146 14.802h9.708l11.146-14.802zM32 1.198h-9.708l-3.063 4.083 4.849 6.427zM19.229 26.734l3.063 4.068h9.708l-7.922-10.51z'/>"];

export { cibExpertsExchange };

